import './envGuard';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Load from './Components/Load';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'react-auth-kit';
import AppThemeProvider from './theme/ThemeContext';
import { AlertProvider, ErrorBoundary } from './Components/ui';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider
        authType={"cookie"}
        authName={"_auth"}
        cookieDomain={window.location.hostname}
        cookieSecure={false}
      >
        <AppThemeProvider>
          <AlertProvider>
            <Suspense fallback={<Load />}></Suspense>
            <App />
          </AlertProvider>
        </AppThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
reportWebVitals();
